import { createFileRoute } from "@tanstack/react-router";
import { IndustryDetailPage } from "@/components/site/IndustryDetailPage";
import { industryDetails } from "@/lib/industry-details";
import { generateServiceSchema, generateBreadcrumbSchema } from "@/components/site/Schema";

const data = industryDetails["nonprofits"]!;

export const Route = createFileRoute("/industries/nonprofits")({
  head: () => ({
    meta: [
      { title: data.metaTitle },
      { name: "description", content: data.metaDescription },
      { property: "og:title", content: data.metaTitle },
      { property: "og:description", content: data.metaDescription },
      { property: "og:url", content: "https://finendra.com/industries/nonprofits" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: data.metaTitle },
      { name: "twitter:description", content: data.metaDescription },
    ],
    links: [{ rel: "canonical", href: "https://finendra.com/industries/nonprofits" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          generateServiceSchema({
            name: "Nonprofit Fund Accounting & Single Audit Workpapers",
            description: data.metaDescription,
            url: "https://finendra.com/industries/nonprofits",
          }),
        ),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify(
          generateBreadcrumbSchema([
            { name: "Home", url: "https://finendra.com" },
            { name: "Industries", url: "https://finendra.com/industries" },
            { name: "Nonprofits & Research", url: "https://finendra.com/industries/nonprofits" },
          ]),
        ),
      },
    ],
  }),
  component: () => <IndustryDetailPage data={data} />,
});
